export const moduleCopy = {
  en: {
    fees: {
      payAtClub: "Pay at club",
      payAtClubBody:
        "Pay this fee at the club. Staff will record cash or a bank transfer and mark the bill paid.",
      payAtClubSaved: "Pay at club saved. The bill stays open until the club records it.",
      recordPayment: "Record payment",
      method: "Method",
      cash: "Cash",
      bankTransfer: "Bank transfer",
      reference: "Reference",
      receiptPath: "Receipt path",
      receiptHint: "Upload a receipt or paste the storage path.",
      markedPaid: "Bill marked paid",
      beforeDue: {
        title: "Programme fee due soon",
        message: "A fee of {{currency}} {{amount}} is due in {{days}} days. Pay at the club.",
      },
      onDue: {
        title: "Programme fee due today",
        message: "A fee of {{currency}} {{amount}} is due today. Pay at the club.",
      },
      overdue: {
        title: "Programme fee overdue",
        message: "A fee of {{currency}} {{amount}} is {{days}} days overdue. Pay at the club.",
      },
    },
    rsvp: {
      label: "RSVP",
      going: "Going",
      maybe: "Maybe",
      notGoing: "Not going",
      saved: "RSVP saved",
      failed: "Could not save RSVP",
      locked: "RSVP is locked for this session",
      note: "Note",
      reminder: "A reminder is sent before the session if nobody has replied",
    },
    household: {
      title: "Household",
      subtitle: "Sessions, fees, and welfare for every linked child",
      sessions: "Upcoming sessions",
      feesDue: "Fees due",
      welfare: "Welfare alerts",
      noSessions: "No sessions in the next two weeks",
      noFees: "No fees due",
      noWelfare: "No open welfare alerts",
      open: "Open household",
      noChildren: "No children are linked to this account.",
      childCard: "Child",
      viewProfile: "View profile",
    },
    dashboard: {
      title: "Club dashboard",
      subtitle: "What needs attention for {{club}}",
      noClub: "No club is assigned to this role yet.",
      players: "Active players",
      programs: "Programmes",
      sessions: "Sessions today",
      outstanding: "Outstanding fees",
      overdue: "Overdue bills",
      applications: "Pending applications",
      collected: "Collected this month",
      openPayments: "Player payments",
      openPrograms: "Programmes",
      openSchedule: "Schedule",
      openClub: "My club",
      adminFocus: "People, programmes, and applications",
      managerFocus: "Today's sessions and the schedule",
      financeFocus: "Fees still open and money collected this month",
    },
    venue: {
      book: "Book",
      title: "Book this slot",
      hold: "Hold for 10 minutes",
      holding: "This slot is held until {{time}}.",
      confirm: "Confirm booking",
      payAtVenue: "Pay at venue",
      stripeTest: "Pay with test checkout",
      confirmed: "Booking confirmed",
      held: "Slot held",
      expired: "The hold expired. Pick the slot again.",
      date: "Date",
    },
    events: {
      rsvp: "RSVP",
      free: "Free",
      ticketReady: "Your ticket is ready",
      checkInTitle: "Event check-in",
      checkInSubtitle: "Scan a ticket QR code or enter the code",
      code: "Ticket code",
      scan: "Start camera",
      stop: "Stop camera",
      checkIn: "Check in",
      checkedIn: "Checked in",
      already: "Already checked in",
      notFound: "Ticket not found",
    },
    password: {
      resetChild: "Reset child password",
      newPassword: "New password",
      confirm: "Confirm password",
      saved: "Child password updated",
      mismatch: "Passwords do not match",
      rules: "Use 8 to 72 characters with upper and lower case, a digit, and a special character.",
      failed: "Could not update the password",
      parentHint:
        "Parents reset a password from the email on their own account. Generated child emails are reset here.",
    },
    welfareNotify: {
      injuryReported: {
        title: "Injury reported",
        message: "{{playerName}} has a reported injury and is unavailable until cleared.",
      },
      acknowledgementNeeded: {
        title: "Acknowledgement needed",
        message: "Please acknowledge clearance before {{playerName}} can return to play.",
      },
      clearedToPlay: {
        title: "Cleared to play",
        message: "{{playerName}} has been cleared to play.",
      },
      concussionRegress: {
        title: "Concussion stage dropped back",
        message: "Symptoms returned. {{playerName}} moved back one return-to-play stage.",
      },
    },
    stats: {
      title: "Player statistics",
      goals: "Goals",
      assists: "Assists",
      matches: "Matches recorded",
      empty: "No match statistics recorded for this club yet.",
    },
    directory: {
      notFound: "That club is not in the directory.",
      members: "Members",
      trophies: "Trophies",
      location: "Location",
    },
  },
  ms: {
    fees: {
      payAtClub: "Bayar di kelab",
      payAtClubBody:
        "Bayar yuran ini di kelab. Kakitangan akan rekod tunai atau pindahan bank dan tandakan bil sebagai dibayar.",
      payAtClubSaved: "Bayar di kelab disimpan. Bil kekal terbuka sehingga kelab merekodkannya.",
      recordPayment: "Rekod bayaran",
      method: "Kaedah",
      cash: "Tunai",
      bankTransfer: "Pindahan bank",
      reference: "Rujukan",
      receiptPath: "Laluan resit",
      receiptHint: "Muat naik resit atau tampal laluan storan.",
      markedPaid: "Bil ditandakan dibayar",
      beforeDue: {
        title: "Yuran program perlu dibayar",
        message: "Yuran {{currency}} {{amount}} perlu dibayar dalam {{days}} hari. Bayar di kelab.",
      },
      onDue: {
        title: "Yuran program perlu dibayar hari ini",
        message: "Yuran {{currency}} {{amount}} perlu dibayar hari ini. Bayar di kelab.",
      },
      overdue: {
        title: "Yuran program tertunggak",
        message: "Yuran {{currency}} {{amount}} telah tertunggak {{days}} hari. Bayar di kelab.",
      },
    },
    rsvp: {
      label: "Pengesahan kehadiran",
      going: "Hadir",
      maybe: "Mungkin",
      notGoing: "Tidak hadir",
      saved: "Pengesahan kehadiran disimpan",
      failed: "Pengesahan kehadiran tidak dapat disimpan",
      locked: "Pengesahan kehadiran dikunci untuk sesi ini",
      note: "Nota",
      reminder: "Peringatan dihantar sebelum sesi jika tiada jawapan",
    },
    household: {
      title: "Isi rumah",
      subtitle: "Sesi, yuran, dan kebajikan untuk setiap anak yang dipautkan",
      sessions: "Sesi akan datang",
      feesDue: "Yuran perlu dibayar",
      welfare: "Amaran kebajikan",
      noSessions: "Tiada sesi dalam dua minggu akan datang",
      noFees: "Tiada yuran perlu dibayar",
      noWelfare: "Tiada amaran kebajikan terbuka",
      open: "Buka isi rumah",
      noChildren: "Tiada anak dipautkan pada akaun ini.",
      childCard: "Anak",
      viewProfile: "Lihat profil",
    },
    dashboard: {
      title: "Papan pemuka kelab",
      subtitle: "Perkara yang perlu perhatian untuk {{club}}",
      noClub: "Tiada kelab ditetapkan untuk peranan ini lagi.",
      players: "Pemain aktif",
      programs: "Program",
      sessions: "Sesi hari ini",
      outstanding: "Yuran tertunggak",
      overdue: "Bil lewat bayar",
      applications: "Permohonan menunggu",
      collected: "Kutipan bulan ini",
      openPayments: "Bayaran pemain",
      openPrograms: "Program",
      openSchedule: "Jadual",
      openClub: "Kelab saya",
      adminFocus: "Orang, program, dan permohonan",
      managerFocus: "Sesi hari ini dan jadual",
      financeFocus: "Yuran masih terbuka dan kutipan bulan ini",
    },
    venue: {
      book: "Tempah",
      title: "Tempah petak masa ini",
      hold: "Tahan selama 10 minit",
      holding: "Petak masa ini ditahan sehingga {{time}}.",
      confirm: "Sahkan tempahan",
      payAtVenue: "Bayar di tempat",
      stripeTest: "Bayar dengan pembayaran ujian",
      confirmed: "Tempahan disahkan",
      held: "Petak masa ditahan",
      expired: "Tahanan telah tamat. Pilih petak masa sekali lagi.",
      date: "Tarikh",
    },
    events: {
      rsvp: "Pengesahan kehadiran",
      free: "Percuma",
      ticketReady: "Tiket anda sudah sedia",
      checkInTitle: "Daftar masuk acara",
      checkInSubtitle: "Imbas kod QR tiket atau masukkan kod",
      code: "Kod tiket",
      scan: "Buka kamera",
      stop: "Hentikan kamera",
      checkIn: "Daftar masuk",
      checkedIn: "Sudah daftar masuk",
      already: "Sudah didaftar masuk",
      notFound: "Tiket tidak dijumpai",
    },
    password: {
      resetChild: "Tetapkan semula kata laluan anak",
      newPassword: "Kata laluan baharu",
      confirm: "Sahkan kata laluan",
      saved: "Kata laluan anak dikemas kini",
      mismatch: "Kata laluan tidak sepadan",
      rules: "Gunakan 8 hingga 72 aksara dengan huruf besar dan kecil, nombor, dan aksara khas.",
      failed: "Kata laluan tidak dapat dikemas kini",
      parentHint:
        "Ibu bapa menetapkan semula kata laluan melalui e-mel akaun sendiri. E-mel anak yang dijana ditetapkan semula di sini.",
    },
    welfareNotify: {
      injuryReported: {
        title: "Kecederaan dilaporkan",
        message: "{{playerName}} dilaporkan cedera dan tidak boleh bermain sehingga dibenarkan.",
      },
      acknowledgementNeeded: {
        title: "Pengesahan diperlukan",
        message: "Sila sahkan pelepasan sebelum {{playerName}} boleh kembali bermain.",
      },
      clearedToPlay: {
        title: "Dibenarkan bermain",
        message: "{{playerName}} telah dibenarkan bermain.",
      },
      concussionRegress: {
        title: "Peringkat gegaran diturunkan",
        message: "Gejala kembali. {{playerName}} diturunkan satu peringkat pemulihan.",
      },
    },
    stats: {
      title: "Statistik pemain",
      goals: "Gol",
      assists: "Bantuan",
      matches: "Perlawanan direkod",
      empty: "Tiada statistik perlawanan direkod untuk kelab ini lagi.",
    },
    directory: {
      notFound: "Kelab itu tiada dalam direktori.",
      members: "Ahli",
      trophies: "Piala",
      location: "Lokasi",
    },
  },
} as const;
